// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.


export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyDmxWMbtqenSc2MbUtAQnVY5iy0eDE4qfM', // gitleaks:allow

    authDomain: 'noovle-preventivatore-eps-dev.firebaseapp.com',

    projectId: 'noovle-preventivatore-eps-dev',

    storageBucket: 'noovle-preventivatore-eps-dev.appspot.com',

    messagingSenderId: '260431508013',

    appId: '1:260431508013:web:860155b689efd0c0d5bea4',

    measurementId: 'G-2FLP450FSJ',
  },
  baseUrl: '/api/v1',
  formIo: {
    apiUrl: 'https://formio.dev.ai-platform.elvoon.it/',
  },
  apiMock: 'http://localhost:4200/public/mock-data',
  lookerDashboardUrl: 'https://lookerstudio.google.com/embed/reporting/4abd56ef-e906-4d27-aa1d-b522b72428d3/page/IuPiF'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */